import { AxiosResponse } from "axios";
import api from "../api";
import { MainUser } from "../slices/authSlice";

type signUpPayload = {
	name: string;
	email: string;
	password: string;
	account_type?: string;
};

export default class FirstAccessApi {
	getEmailAndName(cpf: string) {
		return api.post("/users/login/get_email_and_name", { cpf: cpf });
	}
	sendAuthKeyToEmail(decryptedEmail: string) {
		return api.post("/users/login/send_email", { email: decryptedEmail });
	}
	checkIfAuthKeyIsCorrect(decryptedEmail: string, authenticationKey: string) {
		return api.post("/users/login/otp_login", {
			email: decryptedEmail,
			password: authenticationKey,
		});
	}

	login(email: string, password: string): Promise<AxiosResponse<MainUser>> {
		return api.post("/users/login/signin", {
			email,
			password,
		});
	}

	signUp(data: signUpPayload) {
		return api.post("/users/sign_up/", {
			name: data.name,
			email: data.email,
			password: data.password,
			account_type: data.account_type,
		});
	}

	verifyEmailConfirmation() {
		return api.get("/users/profile/verify_account_status");
	}
	resendEmail() {
		return api.post("/users/sign_up/resent_confirmation_token", {});
	}

	// saveNotificationToken(token: string, account: string) {
	// 	console.log({ token });
	// 	console.log({ account });
	// 	return api.post("/users/notification_token", {
	// 		token: {
	// 			value: token,
	// 			account: account,
	// 		},
	// 	});
	// }
}
